import React, { FC } from 'react';
import { create } from 'zustand';

export interface AccordionStore {
  openItem: string;
  open(id: string): void;
}

const _useAccordionStore = create<AccordionStore>(set => ({
  openItem: '',
  open: id => set({ openItem: id })
}));

export const AccordionProvider: FC = ({ children }) => <>{children}</>;

export const useAccordionStore = _useAccordionStore;
